export const getPaymentMethodAndTypeByPaymentHistoryItemCode = (itemCode) => {
  const itemCodeInt = Number.parseInt(itemCode);
  switch (itemCodeInt) {
    case 1:
      return {
        method: "Check",
        type: "Received",
      };

    case 2:
      return {
        method: "EFT",
        type: "Received",
      };

    case 5:
      return {
        method: "Group Bill",
        type: "Received",
      };

    case 6:
      return {
        method: "Credit Card",
        type: "Received",
      };

    case 8:
    case 9:
      return {
        method: "Waiver of Premium",
        type: "Received",
      };
    case 10:
    case 24:
    case 27:
    case 33:
    case 35:
    case 36:
    case 235:
    case 233:
    case 40:
      return {
        method: "Waiver of Premium",
        type: "Received",
      };

    case 26:
      return {
        method: "EFT/Check/CC",
        type: "Received",
      };

    case 240:
      return {
        method: "EFT Returned",
        type: "Returned",
      };

    case 59:
    case 68:
    case 73:
    case 87:
    case 142:
    case 180:
    case 287:
    case 297:
      return {
        method: "Outgoing",
        type: "Sent",
      };
    // Withdrawal codes
    case 58:
    case 67:
    case 68:
    case 69:
    case 71:
    case 72:
    case 74:
    case 75:
    case 80:
    case 117:
    case 209:
    case 210:
    case 238:
    case 274:
    case 267:
    case 297:
    case 474:
    case 398:
    case 73:
    case 120:
    case 122:
    case 124:
    case 170:
    case 180:
    case 211:
    case 212:
    case 269:
    case 275:
    case 276:
    case 298:
    case 409:
      return {
        method: "Withdrawal",
        type: "Disbursed",
      };

    default:
      return {
        type: itemCode,
        method: itemCode,
      };
  }
};
